import Server from '@/service/server'

export default {
  namespaced: true,
  state: {
    subscriptionRequestResult: {
      subscriptionMethod: '',
      code: ''
    },
    requestStatus: 'None',
    userSubscriptions: [],
    userSubscriptionPlan: ''
  },
  getters: {
    userSubscriptions (state: any) {
      return state.userSubscriptions
    },
    isNewUser (state: any) {
      var item = state.userSubscriptions.find((x: { state: string; planType: string; }) => x.planType === 'Free')
      if (item !== undefined) {
        return true
      }
      return false
    },
    userSubscriptionPlan (state: any) {
      return state.userSubscriptionPlan
    },
    subscriptionRequestResult (state: any) {
      return state.subscriptionRequestResult
    }
  },
  actions: {
    requestForSubscription (context: any, payload: any) {
      let promise = Server.requestForSubscription(payload)
      promise.then((response: any) => {
        let result = response.body.result
        context.commit('requestResultReceived', result)
      })
      return promise
    },
    init (context: any, payload: any) {
      let params = {
        code: payload.code
      }

      let promise = Server.initSubscription(params, payload).then((response: any) => {
        return response
      },
      (error: any) => {
        return error
      })
      return promise
    },
    resend (context: any, payload: any) {
      let promise = Server.resend(payload).then((response: any) => {
        return response
      },
      (error: any) => {
        return error
      })
      return promise
    },

    checkRequestStatus (context: any, code: string) {
      var params = { code: code }
      var promise = Server.checkSubscriptionRequestStatus(params)
      promise.then((response: any) => {
        var result = response.body.result
        context.commit('requestStatusUpdated', result)
      })
      return promise
    },
    verify (context: any, payload: any) {
      let promise = Server.verifyOtp(payload)
      return promise
    },
    getUserStatus (context: any, payload: any) {
      var promise = Server.getUserStatus(payload).then((response:any) => {
        context.commit('userSubscriptionsLoaded', response.body.result)
        return response
      })
      return promise
    },
    getUserStatusZainjo (context: any, payload: any) {
      var promise = Server.getUserStatusZainjo(payload).then((response:any) => {
        return response
      })
      return promise
    },
    getUserState (context: any) {
      var promise = Server.getUserState().then((response: any) => {
        context.commit('userSubscriptionsLoaded', response.body.result)
        return response
      })
      return promise
    },
    getUserSubscriptionPlan (context: any) {
      var promise = Server.getUserState().then((response: any) => {
        if (response.body.result.length > 0) {
          var result = {
            RemainedDays: response.body.result[0].remainingDays,
            ActivePlan: response.body.result[0].planType,
            IsDailyPlan: response.body.result[0].planType === 'Daily'
          }
          context.commit('userSubscriptionPlanLoaded', result)
          return result
        }
      })
      return promise
    },
    unsubscribe (context: any, payload: any) {
      return Server.unsubscribe(payload)
    },
    confirmUnsubscribe (context: any, payload: any) {
      return Server.confirmUnsubscribe(payload)
    },
    alreadySub (context: any, payload: any) {
      let promise = Server.alreadySub(payload)
      promise.then((response: any) => {
        let result = response.body.result
        context.commit('requestResultReceived', result)
      })
      return promise
    },
    checkAlreadyUserSub (context: any, payload: any) {
      return Server.checkAlreadyUserSub(payload)
    },
    getValidations (context: any, payload: any) {
      return Server.getValidations(payload)
    },
    subscriptionWithUrl (context: any, payload: any) {
      let params = {
        username: payload.username
      }
      return Server.registerWithUrl(params, params)
    },
    getTpayDigest (context: any, payload: any) {
      let params = {
        providerCode: payload
      }
      return Server.getTpayDigest(params, params)
    }
  },
  mutations: {
    requestResultReceived (state: any, payload: any) {
      state.subscriptionRequestResult = payload
    },
    requestStatusUpdated (state: any, status: string) {
      state.requestStatus = status
    },
    userSubscriptionsLoaded (state: any, payload: any) {
      state.userSubscriptions = payload
    },
    userSubscriptionPlanLoaded (state: any, payload: any) {
      state.userSubscriptionPlan = payload
    }
  }
}
